import { type FC, type ReactNode } from 'react';
import { Navigation } from './Navigation';
import { Footer } from './Footer';

export interface LayoutProps {
  children: ReactNode;
}

/**
 * Main layout component wrapping all pages
 * Includes navigation, footer, and content area
 */
export const Layout: FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};
